'use strict';

/**
 * Collection of all alert related functions.
 */

// Constants
var SELECTOR = {
    ALERT: '.com-alert',
    ALERT_ITEM: '.com-alert__item',
    ALERT_CLOSE_SPAN: 'span[data-close="true"]'
};
var ATTRIBUTE = {
    DATA: {
        PERSISTENT: 'data-persistent',
        TYPE: 'data-type'
    }
};
var TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info'
};
var DURATION_MS = 5000;

/**
 * Create an alert item with a message, a type and a cross to close the alert if it is persistent.
 * @param {string} message - of the alert
 * @param {string} type - alert type
 * @param {boolean} isPersistent - if true then the alert shows a cross icon to close the alert and does not automatically hide
 * @returns {JQuery<HTMLElement>} Create an alert item jquery element
 */
function buildAlertItem(message, type, isPersistent) {
    var $alertItem = $('<div class="com-alert__item"><span></span></div>');

    $alertItem.find('span').html(message);
    $alertItem.attr(ATTRIBUTE.DATA.TYPE, type);
    $alertItem.attr(ATTRIBUTE.DATA.PERSISTENT, isPersistent);

    if (isPersistent) {
        $alertItem.append(
            '<span class="icon-global--close-bg" data-close="true"></span>'
        );
    }

    return $alertItem;
}

/**
 * Show an alert item with a message, a type and a cross to close the alert if it is persistent.
 * @param {string} message - of the alert
 * @param {string} _type - alert type
 * @param {boolean} isPersistent - if true then the alert shows a cross icon to close the alert and does not automatically hide
 * @returns {undefined} if there is an error
 */
function show(message, _type = TYPE.SUCCESS, isPersistent = false) {
    // Constants
    const $ALERT = $(SELECTOR.ALERT);

    // Variables
    var $alertItem;
    var type = _type;

    // 1. Parameter validations
    if (
        message === null ||
        message === 'undefined' ||
        typeof message !== 'string'
    ) {
        return;
    }

    // 2. Set alert type
    switch (_type) {
        case TYPE.ERROR:
            type = TYPE.ERROR;
            break;
        case TYPE.INFO:
            type = TYPE.INFO;
            break;
        default:
            type = TYPE.SUCCESS;
            break;
    }

    // 3. Set persistent state
    $alertItem = buildAlertItem(message, type, isPersistent);

    // 4. Attach alert item to the alert list
    $ALERT.append($alertItem);

    // 5. Show alert
    $alertItem.animate(
        {
            opacity: 1
        },
        'fast'
    );

    // 6. Hide alert
    if (!isPersistent) {
        setTimeout(function () {
            $alertItem.fadeOut('fast', function () {
                $(this).remove();
            });
        }, DURATION_MS);
    } else {
        $alertItem.find(SELECTOR.ALERT_CLOSE_SPAN).on('click', function () {
            $alertItem.fadeOut('fast', function () {
                $(this).remove();
            });
        });
    }
}

/**
 * Hide the alert from viewport.
 */
function hide() {
    // Constants
    const $ALERT_ITEMS = $(SELECTOR.ALERT_ITEM);

    // 2. Hide alert
    $ALERT_ITEMS.fadeOut('fast', function () {
        $(this).remove();
    });
}

/**
 * JQuery functions
 */
/**
 * Show alert component with the defined message.
 * @param {string} message - to show in alert
 * @param {string} _type - alert type
 * @param {boolean} isPersistent - if true then the alert shows a cross icon to close the alert and does not automatically hide
 */
$.alert = function (message, _type, isPersistent) {
    show(message, _type, isPersistent);
};

$.hideAlert = function () {
    hide();
};
